import React from 'react';
import { LogoSection, StyledCol, StyledRow } from '../styled';

const FooterLogoSection = () => (
  <StyledRow>
    <StyledCol md={4} sm={12}>
      <LogoSection>
        <img
          src="https://cdnc.lms360.vn/2026-03-27/ad91e9c9-da5c-46a6-a91e-41dd1766a341/content/assets/images/vien_khao_thi.png"
          alt="Logo Sách TPHCM"
          className="logo-sach"
        />
        <div className="font-bold logo-part-text">
          VIỆN KHẢO THÍ VÀ ĐÁNH GIÁ CHẤT LƯỢNG <br /> GIÁO DỤC
        </div>
        <div className="partner-text">
          ĐỐI TÁC CUNG CẤP DỮ LIỆU ĐÀO TẠO CHATBOT AI
        </div>
      </LogoSection>
    </StyledCol>
    <StyledCol md={4} sm={12}>
      <LogoSection>
        <a
          href="https://bachkhoa.tech/"
          target="_blank"
          rel="noopener noreferrer">
          <img
            className="logo-bachkhoa"
            src={
              process.env.REACT_APP_STATIC_URL +
              'content/assets/images/logo-khong-nen---color.png'
            }
            alt="Logo BKT"
          />
        </a>
        <div className="logo-text">TẬP ĐOÀN KHOA HỌC CÔNG NGHỆ BÁCH KHOA</div>
        <div className="address-text">
          Trụ sở chính:{' '}
          <a
            href="https://tinyurl.com/5a35vnmu"
            target="_blank"
            rel="noopener noreferrer">
            58/6/9 Thạch Lam, Phường Phú Thạnh, TP.HCM
          </a>
        </div>
        <div>Mã số ĐKDV: 0318391958</div>
        <div className="phone-text">
          Điện thoại:{' '}
          <a target="_blank" href="tel:02871020246" rel="noopener noreferrer">
            (0287)102 0246
          </a>{' '}
          {' - '}
          <a target="_blank" href="tel:0903030246" rel="noopener noreferrer">
            090 303 0246
          </a>
        </div>
        {/* <div className="address-text">
          CN Hà Nội:{' '}
          <span
          // href="https://g.co/kgs/SEu34ht"
          // target="_blank"
          // rel="noopener noreferrer"
          >
            279 Khuất Duy Tiến, Thanh Xuân, Hà Nội
          </span>
        </div>
        <div className="phone-text">
          Điện thoại:{' '}
          <a target="_blank" href="tel:0984268811" rel="noopener noreferrer">
            098 426 8811 
          </a>
        </div> */}
      </LogoSection>
    </StyledCol>
    <StyledCol md={4} sm={12}>
      <LogoSection>
        <img
          src="https://cdnc.lms360.vn/2026-03-27/ad91e9c9-da5c-46a6-a91e-41dd1766a341/content/assets/images/van_phong_bo.png"
          alt="Logo Sách TPHCM"
          className="logo-sach"
        />
        <div className="font-bold logo-part-text">
          TRUNG TÂM PHÁT TRIỂN GDĐT PHÍA NAM <br /> BỘ GIÁO DỤC VÀ ĐÀO TẠO
        </div>
        <div className="partner-text">
          ĐỐI TÁC NGHIÊN CỨU, ỨNG DỤNG KHCN VÀ CHUYỂN ĐỔI SỐ
        </div>
      </LogoSection>
    </StyledCol>
  </StyledRow>
);

export default FooterLogoSection;
